import DashboardTablePagination from "./DashboardTablePagination";

export default DashboardTablePagination;
